import { render } from "./AppSuppliersPage.vue?vue&type=template&id=6f7a4099&ts=true"
import script from "./AppSuppliersPage.vue?vue&type=script&lang=ts"
export * from "./AppSuppliersPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__